<template>
  <tr
    v-if="new Date() - new Date(this.record.creationDateTime) >= 60000"
    :class="{ 'payment-auto': record.paymentSystem, 'blacklisted': record.blackListed, 'fraudSuspected': fraudSuspected, 'accountingSearch': accountingSearch, 'control': !accountingSearch && permission}"
  >
    <td class="moreTd">
      <div
        v-if="
          !record.paymentSystem &&
          record.status === 'created' &&
          $store.state.auth.isUserRoot &&
          $store.state.permissions.moderator_payments
        "
        class="more"
        @click="openMoreInformation"
      >
        <svg
          width="26"
          height="18"
          viewBox="0 0 26 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.99999 7.83331C5.76924 7.83331 5.54368 7.90174 5.35182 8.02993C5.15997 8.15813 5.01043 8.34034 4.92213 8.55352C4.83383 8.7667 4.81072 9.00128 4.85574 9.22759C4.90076 9.4539 5.01187 9.66178 5.17503 9.82494C5.33819 9.9881 5.54607 10.0992 5.77238 10.1442C5.9987 10.1892 6.23327 10.1661 6.44645 10.0778C6.65963 9.98954 6.84184 9.84 6.97004 9.64815C7.09823 9.45629 7.16666 9.23073 7.16666 8.99998C7.16666 8.69056 7.04374 8.39382 6.82495 8.17502C6.60615 7.95623 6.30941 7.83331 5.99999 7.83331ZM20 7.83331C19.7692 7.83331 19.5437 7.90174 19.3518 8.02993C19.16 8.15813 19.0104 8.34034 18.9221 8.55352C18.8338 8.7667 18.8107 9.00128 18.8557 9.22759C18.9008 9.4539 19.0119 9.66178 19.175 9.82494C19.3382 9.9881 19.5461 10.0992 19.7724 10.1442C19.9987 10.1892 20.2333 10.1661 20.4465 10.0778C20.6596 9.98954 20.8418 9.84 20.97 9.64815C21.0982 9.45629 21.1667 9.23073 21.1667 8.99998C21.1667 8.69056 21.0437 8.39382 20.8249 8.17502C20.6062 7.95623 20.3094 7.83331 20 7.83331ZM22.3333 0.833313H3.66666C2.7384 0.833313 1.84816 1.20206 1.19178 1.85844C0.535405 2.51482 0.166656 3.40506 0.166656 4.33331V13.6666C0.166656 14.5949 0.535405 15.4851 1.19178 16.1415C1.84816 16.7979 2.7384 17.1666 3.66666 17.1666H22.3333C23.2616 17.1666 24.1518 16.7979 24.8082 16.1415C25.4646 15.4851 25.8333 14.5949 25.8333 13.6666V4.33331C25.8333 3.40506 25.4646 2.51482 24.8082 1.85844C24.1518 1.20206 23.2616 0.833313 22.3333 0.833313ZM23.5 13.6666C23.5 13.9761 23.3771 14.2728 23.1583 14.4916C22.9395 14.7104 22.6427 14.8333 22.3333 14.8333H3.66666C3.35724 14.8333 3.06049 14.7104 2.8417 14.4916C2.62291 14.2728 2.49999 13.9761 2.49999 13.6666V4.33331C2.49999 4.02389 2.62291 3.72715 2.8417 3.50836C3.06049 3.28956 3.35724 3.16665 3.66666 3.16665H22.3333C22.6427 3.16665 22.9395 3.28956 23.1583 3.50836C23.3771 3.72715 23.5 4.02389 23.5 4.33331V13.6666ZM13 5.49998C12.3078 5.49998 11.6311 5.70525 11.0555 6.08984C10.4799 6.47442 10.0313 7.02105 9.76641 7.66059C9.5015 8.30013 9.43219 9.00386 9.56724 9.6828C9.70229 10.3617 10.0356 10.9854 10.5251 11.4749C11.0146 11.9643 11.6382 12.2977 12.3172 12.4327C12.9961 12.5678 13.6998 12.4985 14.3394 12.2336C14.9789 11.9687 15.5255 11.52 15.9101 10.9445C16.2947 10.3689 16.5 9.69222 16.5 8.99998C16.5 8.07172 16.1312 7.18148 15.4749 6.52511C14.8185 5.86873 13.9282 5.49998 13 5.49998ZM13 10.1666C12.7692 10.1666 12.5437 10.0982 12.3518 9.97003C12.16 9.84183 12.0104 9.65963 11.9221 9.44645C11.8338 9.23326 11.8107 8.99869 11.8557 8.77238C11.9008 8.54606 12.0119 8.33818 12.175 8.17502C12.3382 8.01186 12.5461 7.90075 12.7724 7.85573C12.9987 7.81072 13.2333 7.83382 13.4465 7.92212C13.6596 8.01042 13.8418 8.15996 13.97 8.35182C14.0982 8.54367 14.1667 8.76924 14.1667 8.99998C14.1667 9.3094 14.0437 9.60615 13.8249 9.82494C13.6062 10.0437 13.3094 10.1666 13 10.1666Z"
            fill="white"
          />
        </svg>
      </div>
    </td>
    <td v-if="accountingSearch">
      <div class="accountingBtn" @click="openAccountingInfo">
        <img src="../../assets/images/infoAccounting.png"/>
      </div>
    </td>
    <td class="first-th id">
      {{ record.id }}
      <div class="autopay" v-if="record.paymentSystem">
        <img src="../../assets/images/autopayment-icons/autopay1.svg" alt="" />
        <div class="autopay-hint">
          <p>Автовыплата</p>
        </div>
      </div>
    </td>
<!--    <td>-->
<!--      {{ record.firstName }}-->
<!--      <p v-if="!record.firstName">Не указано</p>-->
<!--    </td>-->
<!--    <td>-->
<!--      {{ record.secondName }}-->
<!--      <p v-if="!record.secondName">Не указано</p>-->
<!--    </td>-->
    <!-- <td class="first-th">{{ record.sourceCurrency }}</td> -->
    <td class="first-th">
      <div class="first-block">
        <p v-if="record.wallet.length != 0">{{ record.wallet }}</p>
        <p v-else>null</p>
      </div>
    </td>
    <td class="first-th">{{ record.userId }}</td>
    <td class="first-th">
      <div
        class="total-block"
        v-if="!ischangeTotal"
        :class="{
          multu: record.sourceCurrency !== record.withdrawalMethodCurrency,
        }"
      >
        <template
          v-if="record.sourceCurrency !== record.withdrawalMethodCurrency"
        >
          <div style="display: flex">
            <p style="text-transform: uppercase">
              {{ record.withdrawalMethodCurrency }}:
            </p>
            <p>{{ record.sourceAmountInFinalCurrency.toFixed(2) }}</p>
          </div>
          <br />
          <div style="display: flex">
            <p style="text-transform: uppercase">
              {{ record.sourceCurrency }}:
            </p>
            <p>{{ record.sourceAmount }}</p>
            <img
              v-if="$store.state.auth.isUserRoot"
              class="total-pen"
              @click="
                (ischangeTotal = true), (recordTotal = record.sourceAmount)
              "
              src="../../assets/images/pen.svg"
              alt=""
            />
          </div>
        </template>
        <template v-else>
          <p>{{ record.sourceAmount }}</p>
          <img
            v-if="$store.state.auth.isUserRoot"
            class="total-pen"
            @click="(ischangeTotal = true), (recordTotal = record.sourceAmount)"
            src="../../assets/images/pen.svg"
            alt=""
          />
        </template>
      </div>
      <div class="change-total" v-else>
        <input
          :class="{ 'error-input': errors.total.status }"
          @keydown.enter="updatePay(record, record.sourceAmount)"
          type="text"
          v-model="record.sourceAmount"
        />
        <img
          class="change-block__ok"
          @click="updatePay(record, record.sourceAmount)"
          src="../../assets/images/ok.svg"
        />
      </div>
    </td>
    <td style="flex-direction: column">
      <template
        v-if="record.sourceCurrency === record.withdrawalMethodCurrency"
      >
        <p>
          <span style="text-transform: uppercase">{{
            record.withdrawalMethodCurrency
          }}</span
          >: {{ record.finalAmount.toFixed(2) }}
        </p>
      </template>
      <template v-else>
        <p>
          <span style="text-transform: uppercase">{{
            record.withdrawalMethodCurrency
          }}</span
          >: {{ record.finalAmount.toFixed(2) }}
        </p>
        <br />
        <p>
          <span style="text-transform: uppercase">{{
            record.sourceCurrency
          }}</span
          >: {{ record.finalAmountInSourceCurrency.toFixed(2) }}
        </p>
      </template>
    </td>
    <td class="first-th">
      <div class="status-block">
        <div
          v-if="!ischangeStatus"
          @click="toggleStatus"
          class="status"
          :class="{
            ok: record.status === 'paid',
            error: record.status === 'failed',
            pending: record.status === 'created',
            fraudBtn: fraudSuspected && record.status !== 'paid' && record.status !== 'failed'
          }"
        >
          <p>{{fraudSuspected && record.status !== 'paid' && record.status !== 'failed' ? "hold" : record.status }}</p>
        </div>
        <div
          class="change-status"
          v-if="ischangeStatus && $store.state.auth.isUserRoot"
        >
          <div class="status ok" @click="selectStatus(record, 'paid')">
            <p>PAID</p>
          </div>
          <div class="status error" @click="selectStatus(record, 'failed')">
            <p>FAILED</p>
          </div>
          <div class="status pending" @click="selectStatus(record, 'created')">
            <p>CREATED</p>
          </div>
        </div>
      </div>
    </td>
    <td>
      {{ record.name }}
    </td>
    <td v-if="!accountingSearch && permission">
      <div class="checkbox" @click="controlFetch">
        <span :class="{'active': record.control}"/>
      </div>
    </td>
    <td v-if="!accountingSearch">
      {{ record.description }}
    </td>
    <td class="first-th">
      {{ parseDate }}
    </td>
    <td>
      <div
        class="compliance"
        :class="{
          ok: record.compliance,
          error: record.compliance === false,
          pending: record.compliance === null,
        }"
      >
        <img
          v-if="record.compliance"
          src="../../assets/images/compliance/ok.svg"
          alt=""
        />
        <img
          v-if="record.compliance === false"
          src="../../assets/images/compliance/error.svg"
          alt=""
        />
        <img
          v-if="record.compliance === null"
          src="../../assets/images/compliance/pending.svg"
          alt=""
        />
      </div>
    </td>
    <div class="information" v-if="accountingSearch" :class="{information_open: accountingInfoOpen, information_all: accountingInfoOpen && isOpenMoreInformation}">
      <div class="information__wrapper accounting_open">
        <div class="accounting__info" v-if="record.accounting.department">
          <span>Department:</span>
          <span>{{record.accounting.department}}</span>
        </div>
        <div class="accounting__info" v-if="record.accounting.direction">
          <span>Direction:</span>
          <span>{{record.accounting.direction}}</span>
        </div>
        <div class="accounting__info" v-if="record.accounting.desc">
          <span>Description:</span>
          <span>{{record.accounting.desc}}</span>
        </div>
        <div class="accounting__info">
          <span>Project:</span>
          <span>{{record.accounting.project}}</span>
        </div>
        <div class="accounting__info" v-if="record.accounting.recipient">
          <span>Recipient:</span>
          <span>{{record.accounting.recipient}}</span>
        </div>
        <div class="accounting__info">
          <span>Type:</span>
          <span>{{record.accounting.type}}</span>
        </div>
        <div class="accounting__info" v-if="record.accounting.type === 'other'">
          <span>Category:</span>
          <span>{{record.accounting.enumDesc}}</span>
        </div>
        <div class="accounting__info" v-if="record.accounting.subEnumDesc">
          <span>SubCategory:</span>
          <span>{{record.accounting.subEnumDesc}}</span>
        </div>
        <div class="accounting__info" v-if="record.accounting.psSourceCurrency">
          <span>Rates:</span>
          <span>
            {{record.finalAmountInSourceCurrency}}
            ({{record.withdrawalMethodCurrency !== record.accounting.psSourceCurrency ?
            (record.accounting.rates[`${record.withdrawalMethodCurrency.toUpperCase()}-${record.accounting.psSourceCurrency.toUpperCase()}`] * record.finalAmountInSourceCurrency).toFixed(2) :
            (record.finalAmountInSourceCurrency)}}
            {{record.accounting.psSourceCurrency}})
<!--            ({{(record.accounting.rates[`${record.withdrawalMethodCurrency.toUpperCase()}-${record.accounting.psSourceCurrency.toUpperCase()}`] * record.finalAmountInSourceCurrency).toFixed(3)}} {{record.accounting.psSourceCurrency}})-->
          </span>
        </div>
      </div>
    </div>
    <div
      class="information"
      v-if="$store.state.auth.isUserRoot"
      :class="{ information_open: isOpenMoreInformation }"
    >
      <MoreInformationLoader v-if="!isProcessedOrder" />
      <div
        class="information__wrapper"
        v-if="
          (moreInformationData && moreInformationData.status) ||
          moreInformationData === null
        "
      >
        <div class="information__btn">
          <button v-if="moreInformationData && moreInformationData.status">
            ПРОВЕДЕНО
          </button>
          <div v-else-if="record.name === 'qiwi'">
            <button @click="processOrder('gm')">ПРОВЕСТИ GM</button>
            <button @click="processOrder('payok')">ПРОВЕСТИ PAYOK</button>
          </div>
          <button v-else @click="processOrder(null)">ПРОВЕСТИ</button>
        </div>
        <div class="information__item">
          <p v-if="moreInformationData && moreInformationData.status">
            <span>ID выплаты:</span>
            {{ moreInformationData.paymentSystemResponse.data.payout_id }}
          </p>
          <p v-else><span>ID выплаты:</span> -</p>
        </div>
        <div class="information__item">
          <p v-if="moreInformationData && moreInformationData.status">
            <span>ОТВЕТ ОТ СЕРВЕРА:</span>
            {{
              moreInformationData.paymentSystemResponse.data.payout_status_text
            }}
          </p>
          <p v-else><span>ОТВЕТ ОТ СЕРВЕРА:</span> -</p>
        </div>
        <div class="information__item">
          <p v-if="moreInformationData && moreInformationData.status">
            <span>Статус:</span>
            {{ moreInformationData.paymentSystemResponse.status }}
          </p>
          <p v-else><span>Статус:</span> -</p>
        </div>
      </div>
      <div
        v-if="moreInformationData && !moreInformationData.status"
        class="information__error"
      >
        <h4>
          {{
            moreInformationData.message ||
            moreInformationData.paymentSystemResponse.errorText ||
          moreInformationData.paymentSystemResponse.text
          }}
        </h4>
      </div>
    </div>
  </tr>
</template>

<script>
import MoreInformationLoader from "../MoreInformationLoader/MoreInformationLoader";
import cookie from "vue-cookie";

export default {
  name: "TabelRow",
  props: ['record', 'accountingSearch', 'permission'],
  data() {
    return {
      isOpenMoreInformation: false,
      recordTotal: 0,
      ischangeWallet: false,
      ischangeTotal: false,
      ischangeStatus: false,
      recod: null,
      errors: {
        total: {
          status: false,
        },
      },
      accountingInfoOpen: false,
      isProcessedOrder: true,
      moreInformationData: null,
    };
  },
  components: {
    MoreInformationLoader,
  },
  computed: {
    parseDate() {
      const d = new Date(this.record.creationDateTime);

      d.setMinutes(d.getMinutes() + -d.getTimezoneOffset());

      return d.toLocaleString("ru-RU", {
        timeZone: "Europe/Moscow",
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      });
    },
    fraudSuspected() {
      const rowDate = new Date (this.record.creationDateTime)
      const currentDate = new Date()
      if ((rowDate.setDate(rowDate.getDate() + 10) > currentDate) && this.record.fraudSuspected && !this.record.isAdmin) {
        return true
      }
    }
  },
  methods: {
    toggleStatus() {
      if (this.$store.state.auth.isUserRoot) this.ischangeStatus = true;
    },
    updatePay(data, pay) {
      if (data.sourceAmount > this.recordTotal) {
        this.errors.total.status = true;
        data.sourceAmount = this.recordTotal;
        return;
      }

      this.ischangeTotal = false;
      this.errors.total.status = false;

      const payload = {
        id: data.id,
        sourceAmount: pay,
        status: data.status,
      };
      this.updateRecord(payload);
    },
    selectStatus(data, currentStatus) {
      this.ischangeStatus = false;
      data.status = currentStatus;
      const payload = {
        id: data.id,
        sourceAmount: data.sourceAmount,
        status: currentStatus,
      };
      this.updateRecord(payload);
    },
    updateRecord(payload) {
      fetch(`https://payments.neuralgeneration.com/api/v1/withdrawals/update`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.tokens.access}`,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((data) => {
        });
    },
    async openMoreInformation() {
      if (!this.$store.state.auth.isUserRoot) return;

      this.isOpenMoreInformation = !this.isOpenMoreInformation;
    },
    openAccountingInfo () {
      this.accountingInfoOpen = !this.accountingInfoOpen
    },
    processOrder(paymentSystem) {
      if (!this.record.withdrawal_method_ps) {
        alert('Данный платежный шлюз не обслуживается')
        return
      }
      this.isProcessedOrder = false;

      // let finalPaymentSystem = paymentSystem;
      //
      // if (!finalPaymentSystem) {
      //   if (["mts", "megaphone", "tele2", "beeline"].includes(this.record.name)) {
      //     finalPaymentSystem = 'fkwallet'
      //   } else if (["qiwi", "gm_cards", "tether", "tether_trc20", "ethereum", "bitcoin", "yoomoney"].includes(this.record.name)) {
      //     finalPaymentSystem = 'gm'
      //   } else if (this.record.name === "robux") {
      //     finalPaymentSystem = 'robux'
      //   } else {
      //     finalPaymentSystem = 'payok'
      //   }
      // }

      fetch(
        `https://payments.neuralgeneration.com/api/v1/withdrawals/process/${this.record.withdrawal_method_ps}/${this.record.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.tokens.access}`,
          },
        }
      )
        .then((res) => {
          if (res.status !== 200) {
            alert(`Ошибка: ${res.status}`)
          }
          return res.json()
        })
        .then((data) => {
          if (data.status) {
            this.record.paymentSystem = data.paymentSystemResponse;
          } else {
            alert(JSON.stringify(data))
          }
          setTimeout(() => {
            this.isOpenMoreInformation = false;
          }, 4000);
          this.isProcessedOrder = true;
          this.moreInformationData = data;
          // if (!data.status) {
          //   this.moreInformationData.paymentSystemResponse = data.paymentSystemResponse
          //   console.log(this.moreInformationData)
          // }

          // if (this.record.name === "qiwi") {
          //   this.moreInformationData.paymentSystemResponse = {
          //     data: {
          //       payout_id: data.paymentSystemResponse.state,
          //       payout_status_text: data.paymentSystemResponse.state,
          //     },
          //     status: data.paymentSystemResponse.state,
          //   };
          // }
        });
    },
    controlFetch() {
      this.record.control = !this.record.control
      fetch("https://payments.neuralgeneration.com/api/v1/withdrawals/withdrawal_control", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookie.get("token")}`,
        },
        body: JSON.stringify({"id": this.record.id, "status": this.record.control})
      })
    }
  },
};
</script>
